import { Language, LanguageMap, Subsidiary, SubsidiaryMap } from '@coolblue-development/constants';

export const LocalizedReadableSubsidiaryMap: SubsidiaryMap<Partial<LanguageMap<string>>> = {
  [Subsidiary.BE]: {
    [Language.ENGLISH]: 'Belgium',
    [Language.FRENCH]: 'Belgique',
    [Language.DUTCH]: 'België',
    [Language.GERMAN]: 'Belgien'
  },
  [Subsidiary.DE]: {
    [Language.GERMAN]: 'Deutschland',
    [Language.ENGLISH]: 'Germany',
    [Language.DUTCH]: 'Duitsland',
    [Language.FRENCH]: 'Allemagne'
  },
  [Subsidiary.NL]: {
    [Language.ENGLISH]: 'The Netherlands',
    [Language.DUTCH]: 'Nederland',
    [Language.FRENCH]: 'Pays-Bas',
    [Language.GERMAN]: 'Niederlande'
  }
};
